// extracted by mini-css-extract-plugin
export default {"userinput":"UserInput_userinput__hiOpQ"};